import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Image, TouchableOpacity } from '@applane/react-core-components';
import { Table, Text } from '../../../app-components';
import { getUser } from '../../../AppServices';
import { MODELS } from '../../../Lib/constants';
import { modifyDateView, shorten } from '../../../Lib/helpers';
import { appraisalHoverIcon, appraisalIcon } from '../../../images';


let storedData = JSON.parse(localStorage.getItem('appraisalFailedState'));
let avFail = JSON.parse(localStorage.getItem('avFail'));


const ListButton = (props) => {
  const [hover, setHover] = useState(false);
  const { navigation } = props;
  console.log('navigation', navigation)
  console.log("Props", props)
  return (
    <>
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="float"
        id="fi-sale-close-button"
      />

      <TouchableOpacity
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onFocus={() => setHover(true)}
        onPress={() => {
          navigation.push({
            view: 'manual-appraisal-modal',
            params: { data: props?.item },
            modal: true,
            modalProps: { backgroundColor: 'transparent' },
          });
        }}
      >
        <div data-tip="Appraise" data-for="fi-sale-close-button">
          <Image
            style={{
              height: 24,
              width: 24,
              cursor: 'pointer',
              filter:
                'invert(7%) sepia(99%) saturate(7489%) hue-rotate(247deg) brightness(109%) contrast(140%)',
            }}
            source={hover ? appraisalHoverIcon : appraisalIcon}
          />
        </div>
      </TouchableOpacity>
    </>
  );
};

const tableItems = {
  lg: {
    columns: [
      avFail ? storedData?.Name && {
        header: 'Name',
        width: 300,
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{item?.cdk?.name}</Text>
        ),
      } : {
        header: 'Name',
        width: 300,
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{item?.cdk?.name}</Text>
        ),
      },
      avFail ? storedData?.Email && {
        header: 'Email',
        width: 300,
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.email, 100)}</Text>
        ),
      } : {
        header: 'Email',
        width: 300,
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.email, 100)}</Text>
        ),
      },
      avFail ? storedData?.Phone && {
        header: 'Phone#',
        width: 250,
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>
            {shorten(item?.cdk?.contactNumber, 100)}
          </Text>
        ),
      } : {
        header: 'Phone#',
        width: 250,
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>
            {shorten(item?.cdk?.contactNumber, 100)}
          </Text>
        ),
      },
      avFail ? storedData?.DateGenerated && {
        header: 'Date Generated',
        // type: 'date',
        // field: 'onDate',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{modifyDateView(item?.onDate)}</Text>
        ),
        width: 200,
      } : {
        header: 'Date Generated',
        // type: 'date',
        // field: 'onDate',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{modifyDateView(item?.onDate)}</Text>
        ),
        width: 200,
      },
      avFail ? storedData?.Mileage && {
        header: 'Mileage',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>
            {item?.cdk?.mileage}
          </Text>
        ),
        width: 200,
      } : {
        header: 'Mileage',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>
            {item?.cdk?.mileage}
          </Text>
        ),
        width: 200,
      },
      avFail ? storedData?.Year && {
        header: 'Year',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.year)}</Text>
        ),
        width: 200,
      } : {
        header: 'Year',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.year)}</Text>
        ),
        width: 200,
      },
      avFail ? storedData?.Make && {
        header: 'Make',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.make, 22)}</Text>
        ),
        width: 200,
      } : {
        header: 'Make',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.make, 22)}</Text>
        ),
        width: 200,
      },
      avFail ? storedData?.Model && {
        header: 'Model',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.model, 22)}</Text>
        ),
        width: 200,
      } : {
        header: 'Model',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.model, 22)}</Text>
        ),
        width: 200,
      },
      avFail ? storedData?.VIN && {
        header: 'VIN',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.vin, 22)}</Text>
        ),
        width: 200,
      } : {
        header: 'VIN',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{shorten(item?.cdk?.vin, 22)}</Text>
        ),
        width: 200,
      },
      avFail ? storedData?.Reason && {
        header: 'Reason',
        render: ({ item }) => {
          const failedResult = item?.failedResult ? JSON.parse(item.failedResult) : [];
          const failedDetails = failedResult.reduce((acc, result) => {
            const failed = result.details.filter(detail => !detail.Passed);
            if (failed.length > 0) {
              acc.push({ ruleName: result.ruleName, details: failed });
            }
            return acc;
          }, []);

          return (
            <div style={{ fontSize: 16 }}>
              {item.errorCause === 'Rule failure' ?

                failedDetails.map((failedResult, index) => (
                  <div key={index} style={{ textAlign: "left", width: "300px", marginLeft: "100px" }}>
                    <p><strong>Rule Name:</strong> {failedResult.ruleName}</p>
                    {failedResult.details.map((detail, idx) => (
                      <p key={idx}>{detail.Field}: Failed</p>
                    ))}
                  </div>
                ))
                :
                item.errorCause
              }
            </div>
          );
        },
        width: 400,
      } : {
        header: 'Reason',
        render: ({ item }) => {
          const failedResult = item?.failedResult ? JSON.parse(item.failedResult) : [];
          const failedDetails = failedResult.reduce((acc, result) => {
            const failed = result.details.filter(detail => !detail.Passed);
            if (failed.length > 0) {
              acc.push({ ruleName: result.ruleName, details: failed });
            }
            return acc;
          }, []);

          return (
            <div style={{ fontSize: 16 }}>
              {
                item.errorCause === 'Rule failure' ? (
                  failedDetails.reduce((uniqueRules, failedResult) => {
                    const existingRule = uniqueRules.find(
                      (rule) => rule.ruleName === failedResult.ruleName
                    );
                    if (!existingRule) {
                      uniqueRules.push(failedResult);
                    }
                    return uniqueRules;
                  }, []).map((uniqueResult, index) => (
                    <div key={index} style={{ textAlign: "left", width: "300px", marginLeft: "100px" }}>
                      <p><strong>Rule Name:</strong> {uniqueResult.ruleName}</p>
                      {uniqueResult.details.map((detail, idx) => (
                        <p key={idx}>{detail.Field}: Failed</p>
                      ))}
                    </div>
                  ))
                ) : (
                  item.errorCause
                )
              }
            </div>
          );
        },
        width: 400,
      },
      avFail ? storedData?.Action && {
        header: 'Actions',
        type: 'text',
        width: 200,
        render: (props) => <ListButton {...props} />,
      } : {
        header: 'Actions',
        type: 'text',
        width: 200,
        render: (props) => <ListButton {...props} />,
      },

    ],
  },
};

export default Table({
  uri: () => {
    const user = getUser();
    let addOnFilter = {};

    if (user.role.code === 'dealer' || user.role.code === 'superdealer') {
      addOnFilter = { name: user.username };
    } else if (user.role.code === 'employee' || user.role.code === 'manager') {
      addOnFilter.name = user.dealer.username;
    }

    return {
      query: {
        id: 'cdkListAll',
        addOnFilter,
      },
      aggregate: true,
      model: MODELS.AVFailCount,
    };
  },
  ...tableItems,
});